<template>
  <v-dialog
    v-model="showDialog"
    persistent
    max-width="600"
    class="user-transfer-dialog"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="user-transfer-dialog_show-btn"
        dark
        color="#ff9100"
        height="40"
        v-bind="attrs"
        v-on="on"
      >
        OK
      </v-btn>
    </template>
    <v-card class="user-transfer-dialog_modal">
      <div class="modal-title text-uppercase">
        ВЫПОЛНИТЬ ПЕРЕМЕЩЕНИЕ?
      </div>
      <div class="modal-user-info d-flex align-center">
        <avatar :user="user"/>
        <div class="modal-user-info_name">
          {{ user.name }}
        </div>
      </div>
      <div class="modal-to-filial d-flex align-center">
        <img src="/img/stat/icons/icon-to-filial.svg" alt="" class="modal-to-filial_icon">
        <div class="modal-to-filial_label-block">
          <div class="modal-to-filial_label">
            филиал:
          </div>
          <div class="modal-to-filial_name">
            {{ toFilial.name }}
          </div>
        </div>
      </div>
      <div class="modal-actions">
        <v-row>
          <v-col cols="6">
            <v-btn
              dark
              color="#C4CDD9"
              @click="cancelTransfer"
              large
              block
              class="modal-actions_btn button-cancel"
              :loading="loading"
            >
              ОТМЕНА
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              dark
              color="#ff9100"
              @click="makeTransfer"
              large
              block
              class="modal-actions_btn button-ok"
              :loading="loading"
            >
              ПОДТВЕРДИТЬ
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
  import Avatar from '@/components/administrator/work-shift/staff/Avatar'
  import SnackbarMessage from '@/mixins/snackbar-message'

  export default {
    name: 'UserTransferConfirmDialog',
    components: { Avatar },
    mixins: [SnackbarMessage],
    props: {
      user: {
        type: Object,
        default: () => ({}),
      },
      toFilial: {
        type: Object,
        default: () => ({}),
      },
      workScheduleId: Number,
      workSpaceId: Number,
    },
    data () {
      return {
        showDialog: false,
        loading: false,
      }
    },
    methods: {
      cancelTransfer () {
        this.showDialog = false
        this.$emit('cancel')
      },
      makeTransfer () {
        this.loading = true

        const payload = {
          targetFilialId: this.toFilial.id,
          userId: this.user.id,
          workSpaceId: this.workSpaceId,
          workScheduleId: this.workScheduleId,
        }

        this.$store.dispatch('dayWorkSchedule/startWorkScheduleTransfer', payload)
          .catch((err) => this.showErrorFromResponse(err))
          .finally(() => {
            this.loading = false
            this.showDialog = false
          })
      },
    },
  }
</script>

<style lang="less" scoped>
  .user-transfer-dialog {

    &_show-btn {
      margin-left: 15px;
      padding: 0 5px;
      min-width: 50px;
      font-size: 12px;
    }

    &_modal {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 50px 40px;
      background: #F1F3F6;
      .media-sm({
        padding: 20px;
      });

      .modal-title {
        font-size: 32px;
        margin-bottom: 15px;
        .media-sm({
          margin-bottom: 30px;
          font-size: 20px;
        })
      }

      .modal-user-info {
        margin-bottom: 5px;

        &_name {
          margin-left: 10px;
          background: #fff;
          height: 42px;
          display: flex;
          align-items: center;
          min-width: 180px;
          padding: 0 15px;
          border-radius: 7px;
        }
      }

      .modal-to-filial {
        &_icon {
          margin-right: 20px;
          margin-top: 15px;
        }

        &_label {
          color: #9D9B9B;
        }

        &_name {
          text-transform: uppercase;
          line-height: 1;
        }

      }

      .modal-actions {
        width: 100%;
        padding: 50px 60px 0 60px;
        &_btn {

        }

        .media-sm({
          padding: 40px 0 0 0;
        });
      }
    }
  }
</style>
